import CustomPagination from "components/CommonComponents/ReactTable/CustomPagination";
import AdminHeader from "components/Headers/AdminHeader";
import { DEFAULT_RECORDS_PER_PAGE } from "constants/CommonConstants";
import React, { useState } from "react";
import {
  Table,
  Button,
  Badge,
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
} from "reactstrap";

const DOCUMENT_STATUS = {
  PENDING: { value: "PENDING", label: "Pending" },
  APPROVED: { value: "APPROVED", label: "Approved" },
  REJECTED: { value: "REJECTED", label: "Rejected" },
};

const dummyCourses = [
  {
    ID: 1,
    name: "React Basics",
    role: "Student",
    assignedCertificate: "React Certificate",
    reportingToName: "John Doe",
    dueDate: "2025-12-25",
    status: "PENDING",
  },
  {
    ID: 2,
    name: "Advanced JavaScript",
    role: "Student",
    assignedCertificate: "JS Certificate",
    reportingToName: "Jane Smith",
    dueDate: "2025-12-28",
    status: "APPROVED",
  },
  {
    ID: 3,
    name: "Node.js & Express",
    role: "Student",
    assignedCertificate: "Node Certificate",
    reportingToName: "Mike Johnson",
    dueDate: "2026-01-05",
    status: "REJECTED",
  },
  {
    ID: 4,
    name: "Database Design",
    role: "Student",
    assignedCertificate: "DB Certificate",
    reportingToName: "Alice Brown",
    dueDate: "2026-01-10",
    status: "PENDING",
  },
  {
    ID: 5,
    name: "CSS & HTML",
    role: "Student",
    assignedCertificate: "Frontend Certificate",
    reportingToName: "Bob White",
    dueDate: "2026-01-15",
    status: "APPROVED",
  },
];


function SampleTable() {
  const [courses, setCourses] = useState(dummyCourses);
  const [pageNum, setPageNum] = useState(1);

  const handleMarkAsPending = (courseID) => {
    setCourses((prev) =>
      prev.map((c) => (c.ID === courseID ? { ...c, status: "PENDING" } : c))
    );
  };

  // This will remove upon API integration
  const startIndex = (pageNum - 1) * DEFAULT_RECORDS_PER_PAGE;
  const endIndex = startIndex + DEFAULT_RECORDS_PER_PAGE;
  const currentPageCourses = courses.slice(startIndex, endIndex);

  return (
    <>
      <AdminHeader name="Camping" />
      <Container className="mt--6" fluid>
        <Row>
          <Col>
            <Card>
              <CardHeader>
                <div className="d-flex">
                  <h3 className="mb-0 mr-1">Compliance Reports</h3>
                </div>
              </CardHeader>
              <CardBody>
                <Row
                  className="d-flex pl-3 mb-4 align-items-center"
                  style={{ gap: "1rem" }}
                >
                  <Table hover responsive>
                    <thead className="thead-light">
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Role</th>
                        <th>Assigned Certificate</th>
                        <th>Reporting To</th>
                        <th>Due Date</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentPageCourses.map((course, index) => (
                        <tr key={course.ID}>
                          <td>{startIndex + index + 1}</td>
                          <td>{course.name}</td>
                          <td>{course.role}</td>
                          <td>
                            <span className="text-primary cursor-pointer">
                              {course.assignedCertificate}
                            </span>
                          </td>
                          <td>{course.reportingToName}</td>
                          <td>{course.dueDate}</td>
                          <td>
                            <Badge
                              color={
                                course.status === "APPROVED"
                                  ? "success"
                                  : course.status === "REJECTED"
                                  ? "danger"
                                  : "warning"
                              }
                              pill
                            >
                              {DOCUMENT_STATUS[course.status]?.label ||
                                course.status}
                            </Badge>
                          </td>
                          <td>
                            <div
                              className="d-flex flex-wrap"
                              style={{ gap: "0.5rem" }}
                            >
                              <Button color="secondary" size="sm" outline>
                                <i className="fas fa-info-circle mr-1" />
                                View
                              </Button>

                              {course.status !== "PENDING" && (
                                <Button
                                  color="secondary"
                                  size="sm"
                                  outline
                                  onClick={() => handleMarkAsPending(course.ID)}
                                >
                                  <i className="fa fa-undo mr-1" />
                                  Mark as Pending
                                </Button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <CustomPagination
                    totalPages={Math.ceil(
                      courses.length / DEFAULT_RECORDS_PER_PAGE
                    )} //Math.ceil(data?.data?.totalRecords / data?.data?.noOfRecordsPerPage)
                    setPageNum={setPageNum}
                    activePage={pageNum}
                  />
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default SampleTable;
